import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PointsMechanismService } from '../../../shared/point-mechanism.service';
import { Subscription } from 'rxjs';
import { FrameShowService } from '../../../shared/FrameShowService';
import { ActivityService } from 'src/app/shared/activity.service';

declare function dragNDrop(data: any);

declare function destroyDragNDrop();

@Component({
    selector: 'app-drag-n-drop',
    templateUrl: './drag-n-drop.component.html',
    styleUrls: ['./drag-n-drop.component.scss'],
    standalone: false
})
export class DragNDropComponent implements OnInit, OnDestroy {
    protected subscription: Subscription;
    userInfo: any;
    loading: boolean;
    data: any;
    id: any;

    constructor(private activatedRoute: ActivatedRoute,
        private ngZone: NgZone,
        private frame: FrameShowService,
        private pm: PointsMechanismService,
        public activityService: ActivityService) {

        window[`angularComponentRef`] = {
            component: this,
            zone: this.ngZone,
            gameFinish: (value) => this.gameFinish(value),
            backToMenu: () => this.backToMenu(),
            nextActivity: () => this.nextActivity(),
            getTotalScore: () => this.getTotalScore(),
            loadingFinished: () => this.loadingFinished()
        };
    }

    ngOnInit() {
        this.frame.useV3();
        this.frame.callAfterDone(() => {
            this.subscription = this.activatedRoute.params.subscribe((data) => {
                console.log(data);
                this.id = data[`id`];

                this.pm.getUserInfo.subscribe(userInfo => {
                    this.userInfo = userInfo;
                });

                this.pm.start(this.id, data[`activityId`]);

                this.activityService.getActivityData({ zoneId: this.id, activityId: data.activityId }).subscribe(aData => {
                    setTimeout(() => {
                        if (data[`id`][0] == '1') aData.activityData['zone'] = "ASIA";
                        if (data[`id`][0] == '2') aData.activityData['zone'] = "EUROPE";
                        dragNDrop(aData.activityData);
                    }, 500);

                    this.data = aData.activityData;
                });
            });
        });
    }

    backToMenu() {
        this.pm.backToActivityList();
    }

    nextActivity() {
        this.pm.nextActivity();
    }

    getTotalScore() {
        return this.userInfo.totalScore;
    }

    loadingFinished() {
        this.loading = false;
    }

    gameFinish(value: any) {
        this.pm.collectPoint(value.score, this.data.progressType);
    }

    ngOnDestroy(): void {
        window[`angularComponentRef`] = null;
        destroyDragNDrop();
        if(this.subscription) this.subscription.unsubscribe();
    }

}
